export type WidgetStatusMap = Record<string, unknown>;

export function isMappedStatus(
  statusCode: string | undefined,
  statusMap: WidgetStatusMap
): boolean {
  return !!statusCode && statusCode in statusMap;
}
